module.exports = __webpack_public_path__ + "img/australia-tuberculosis-male.b0ba6ddc.png";